// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"85351849","239":"ad40150f","455":"22d4e1b1","608":"d69a4408","642":"3d4088db","679":"c6c876a2","718":"c4c2c6a1","762":"f558bc16","977":"6a7f6471","981":"93ce8b54"}[chunkId] + ".chunk.js";
};